import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/**
 * Which tab of the Deliverables list page is active. The two deliverable tab
 * values double as the list endpoint's `scope`, so the tab and the request stay
 * in sync without a second mapping.
 */
export enum DeliverableTab {
  MINE = "mine",
  SHARED = "shared",
  TEMPLATES = "templates",
}

interface DeliverableListStore {
  activeTab: DeliverableTab;
  setActiveTab: (tab: DeliverableTab) => void;
}

export const useDeliverableList = create(
  persist<DeliverableListStore>(
    (set) => ({
      activeTab: DeliverableTab.MINE,
      setActiveTab: (tab: DeliverableTab) => {
        set({ activeTab: tab });
      },
    }),
    {
      name: "deliverableListStore",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
